import isEmpty from 'lodash/isEmpty';
import keyBy from 'lodash/keyBy';
import values from 'lodash/values';
import {
    fetchPesConfiguration,
    patchPesConfiguration,
    validateConfig,
    validateExcludeWeekendsType,
    validateStickinessUserBaseType,
} from './product-engagement-score.utils.js';

let loadAllPromise;

export function __resetLoadAllPromiseForUnitTests () {
    loadAllPromise = null;
}

export default {
    namespaced: true,
    state: {
        // Mapping of App ID => PES Config
        map: {},
        // Mapping of App ID => Update Error
        errors: {},
    },
    mutations: {
        setErrors (state, error) {
            state.errors = error;
        },
        setMap (state, map) {
            state.map = map;
        },
        resetPesErrors (state, { pesAppId = null } = {}) {
            if (pesAppId) {
                state.errors[pesAppId] = null;

                return;
            }
            state.errors = {};
        },
    },
    actions: {
        async loadAll ({ state, commit }, { reFetch = false } = {}) {
            // if we have data or are waiting on it, ~and~ we don't want to refetch, just return the promise.
            if ((!isEmpty(state.map) || loadAllPromise) && !reFetch) {
                return loadAllPromise;
            }

            loadAllPromise = fetchPesConfiguration();
            const resp = await loadAllPromise;

            // BE originally set this default value to "false" (String). This is to ensure POC customers have the correct type set
            let configData = validateExcludeWeekendsType(resp.data);
            // Early on, stickiness type was hardcoded to "visitors". Now that the option is configurable, we want to ensure it is defined in all configs.
            configData = validateStickinessUserBaseType(configData);

            commit('setMap', keyBy(configData, 'appId'));
        },
        async update ({ commit, dispatch }, update) {
            const resp = await patchPesConfiguration({
                pesConfigurations: update.map((updateValues) => {
                    validateConfig(updateValues.configuration);
                    const { id, appId, configuration } = updateValues;

                    return { id, appId, configuration };
                }),
            });
            const errors = {};

            // Ensure all configurations successfully updated. In the case of a
            // partial success, the PATCH request will still return a 200 OK.
            resp.data.forEach(({ code, message, pesConfiguration }) => {
                if (code !== 200) {
                    errors[pesConfiguration.appId] = message;
                }
            });
            commit('setErrors', errors);
            await dispatch('loadAll', { reFetch: true });

            if (!isEmpty(errors)) {
                throw new Error('Failed to save all configurations');
            }
        },
    },
    getters: {
        configByAppId: (state) => (id) => state.map[id],
        list: (state) => values(state.map),
    },
};
